import { tip } from '@/components/messages/ChatTooltip';
/**
 * OnlineStatus Component
 * Indicatore di stato online/typing
 */

interface OnlineStatusProps {
  isOnline?: boolean;
  isTyping?: boolean;
  size?: 'sm' | 'md';
  className?: string;
}

export function OnlineStatus({
  isOnline = false,
  isTyping = false,
  size = 'sm',
  className = '',
}: OnlineStatusProps) {
  if (!isOnline && !isTyping) return null;

  const sizeClasses = {
    sm: 'w-2.5 h-2.5',
    md: 'w-3 h-3',
  };

  return (
    <span
      className={`
        ${sizeClasses[size]}
        rounded-full
        border-2 border-white dark:border-gray-900
        ${isTyping ? 'bg-[#2383E2] animate-pulse' : 'bg-green-500'}
        ${className}
      `}
      {...tip(isTyping ? 'Sta scrivendo...' : 'Online')}
    />
  );
}
